<template>
   <div class="invitation">
       <headerTab :tabList="tabList"></headerTab>
       <el-button class="invitation_btn" type="primary" id="copycardid" v-clipboard:copy="copyUrl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制链接分享好友</el-button>
       <div class="invitation_box">
           <img class="invitation_box_banner" src="../../assets/invitation/invitation_logo.png" alt="">
           <div class="invitation_box_title">已成功邀请<span>{{total}}</span>名好友</div>
           <div class="invitation_box_list" v-for="(item,index) in inviteList" :key="index">
               <div class="invitation_box_list_left">
                   <img :src="$imgUrl + avatar" alt="">
                   <p>{{item.username}}</p>
               </div>
               <div>
                   累积消费：¥{{item.consumption_price}}
               </div>
               <div>
                   累计分拥：¥{{item.commission_price}}
               </div>
           </div>
           <div class="invitation_box_no" v-if="inviteList.length == 0">
               <img src="../../assets/null.png" alt="">
               <p>暂无数据</p>
           </div>
       </div>
       <div class="invitation_pagination" v-if="total > 0">
            <el-pagination
                background
                layout="prev, pager, next"
                :pager-count="9"
                @current-change="handleCurrentChange"
                :current-page="pageNumber"
                :page-size="pageSize"
                :total="total">
            </el-pagination>
            <div class="invitation_pagination_right">
                <div class="invitation_pagination_right_num"><span>{{pageNumber}}</span>/{{lastPage}}</div>
                <div class="invitation_pagination_right_input">
                    到第
                    <el-input v-model="pageNumberInput" size="small" style="width:63px"></el-input>
                    页
                </div>
                <div class="invitation_pagination_right_btn">
                    <el-button size="small" @click="changeNumberInput">确定</el-button>
                </div>
            </div>
        </div>
        <div class="invitation_rule">
            <div>活动规则</div>
            <p>1.活动时间: 2017年8月14日0:00:00-2017年8月20日23:59:59 </p>
            <p>2.参与条件: 1、所购买商品为指定自营家用电器和家装建材(含彩电、冰洗、厨卫、空调、生活电器、建材六个品类,不含虚拟商品); 2... </p>
            <p>3.券详情及时间: 1、奖品以等值易券形式发送,返优惠券时间:在顾客下单支付完成后24小时内... </p>
            <p>4.售后规则 1、返券已经使用,如家电订单产生退货,退货金额为商品的实际支付总价减去返券的...</p>
           
        </div>
   </div>
</template>

<script>
import headerTab from '../../components/header_tab'
import Clipboard from 'clipboard'; 
export default {
   data (){
       let userMessage = JSON.parse(localStorage.getItem('userMessage') || '{}');
       console.log(userMessage);
       var clipBoardContent = window.location.origin;
       return {
           tabList:[
               {name:'邀请返现',id:1}
           ],
           inviteList:[],
           num:1,
           loading:false,
           copyUrl:clipBoardContent + '?&fid=' + userMessage.id,
           pageSize:10,
           pageNumber:1,
           pageNumberInput:1,
           total:0,
           lastPage:0
       }
   },
   components: {
       headerTab
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       onCopy(){
           this.$message.success('复制成功');
       },
       onError(){
           this.$message.error('复制失败');
       },
       //    切换页码
       handleCurrentChange(val){
           this.pageNumber = val;
            this.pageNumberInput = val;
            this.getInviteList();
       },
        // 手动输入页码后确定
       changeNumberInput(){
            if(parseInt(this.pageNumberInput) > this.lastPage){
                this.$message.error('当前页码大于总页码！');
                return 
            }
            this.pageNumber = parseInt(this.pageNumberInput);
            this.getInviteList();
       },
       getInviteList(){
           this.inviteList = [];
           this.loading = true;
           this.$get('InviteFriend',{page_size:this.pageSize,page_index:this.pageNumber})
            .then(data => {
                
                this.inviteList = data.data;
                this.total = data.total;
                this.lastPage = data.last_page;
                this.loading = false;
            } , error => {
                this.loading = false;
                this.$message.error(error);
            });
       }
   },
   created() {

   },
   mounted() {
       this.getInviteList();
   }
}
</script>

<style scoped lang='less'>
.invitation{
    position: relative;
    /deep/ .invitation_btn.el-button{
        position: absolute;
        width:160px;
        top:0;
        right:0;
        font-size: 14px;
    }
    &_box{
        padding: 20px 20px 0 20px;
        min-height: 618px;
        &_no{
            text-align: center;
            margin-top:20px;
            img{
                width:303px;
                height: 255px;
            }
            p{
               font-size: 18px;
               color:#333;
               margin-top:8px; 
               font-weight: 500;
            }
        }
        &_banner{
            width:100%;
        }
        &_title{
            margin-top:20px;
            color:#666666;
            font-size: 14px;
            span{
                font-size: 20px;
                color:#1F9EFF;
                font-weight: 500;
            }
        }
        &_list{
            display: flex;
            justify-content: space-between;
            padding: 16px 0;
            border-bottom: 1px solid #E3E3E4;
            &_left{
                display: flex;
                align-items: center;
                img{
                    width:30px;
                    height:30px;
                    border-radius: 15px;
                }
                p{
                    font-weight: 500;
                    margin-left:11px;
                }
            }
        }
    }
    &_pagination{
        padding-top:30px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color:#000000;
        /deep/ .el-pager li,/deep/ .btn-next, /deep/ .btn-prev{
            min-width: 36px;
            height: 36px;
            padding-top:4px;
            margin: 0 4px;
        }
        /deep/ .btn-prev{
            margin-left: 0;
        }
        &_right{
            display: flex;
            align-items: baseline;
            &_num{
                span{
                    color:#3D7FFF;
                }
                
            }
            &_input{
                margin:0 10px;
            }
            &_btn{
                /deep/ .el-button{
                    background:#F0F2F5;
                    height: 36px;
                    border:1px solid #D7DBE0;
                    font-size: 14px;
                    color:#333;
                }
                /deep/ .el-button:hover{
                    color: #409EFF;
                    border-color: #c6e2ff;
                    background-color: #ecf5ff;
                }
                
            }
        }
    }
    &_rule{
        background:#F5F5F5;
        width:calc(100% + 40px);
        position: relative;
        left: -20px;
        top: 20px;
        div{
            padding: 20px 0;
            font-size: 18px;
        }
        p{
            font-size: 16px;
            line-height: 24px;
            color:#999999;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/invitation/invitation.vue